<template>
  <div>
    <component
      class="my-5"
      persistentHint
      :is="questionComponent"
      v-if="showQuestion"
      :question="question"
      :label="labelText"
      :hint="question.instructionText"
      :disabled="disabled"
      :required="required"
    />
    <div v-if="showQuestion && question.revisionNote">
      <v-alert border="left" color="orange" dense outlined text>
        <span class="revision-request"
          ><span class="revision-request-note">Requested Revision: </span
          >{{ question.revisionNote }}</span
        >
      </v-alert>
      <v-divider></v-divider>
    </div>
  </div>
</template>

<script>
import RadioQuestion from "./RadioQuestion";
import TextQuestion from "./TextQuestion";
import SignatureQuestion from "./SignatureQuestion";
import DateQuestion from "./DateQuestion";
import FileUploadQuestion from "./FileUploadQuestion";
import CheckboxQuestion from "./CheckboxQuestion";
import DropdownQuestion from "./DropdownQuestion";
import AddressQuestion from "./AddressQuestion";
import EVDDisplayText from "./EVDDisplayText";

export default {
  name: "Question",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    question: {
      type: Object,
      default: () => ({
        dataPointId: 0,
        required: false,
        characterLimit: 0,
        labelText: "Radio Question 1",
        instructionText: "Instructional Text",
        dataType: "SINGLE_SELECT",
        displayType: "RADIO",
        revisionNote: "",
        value: null,
        choices: [],
        expressions: [],
        rulesThatWouldShowQuestion: [],
        rulesThatWouldRequireQuestion: []
      })
    },
    satisfiedRules: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    questionComponent() {
      switch (this.question.displayType) {
        case "RADIO":
          return RadioQuestion;
        case "TEXT":
          return TextQuestion;
        case "DATE":
          return DateQuestion;
        case "FILE":
          return FileUploadQuestion;
        case "CHECKBOX":
          return CheckboxQuestion;
        case "DROPDOWN":
          return DropdownQuestion;
        case "DISPLAY_TEXT":
          return EVDDisplayText;
        case "SIGNATURE":
          return SignatureQuestion;
        case "ADDRESS":
          return AddressQuestion;
        default:
          return RadioQuestion;
      }
    },
    labelText() {
      if (this.required) return this.question.labelText + "*";
      else return this.question.labelText;
    },
    showQuestion() {
      if (this.question.rulesThatWouldShowQuestion?.length === 0) return true;
      return this.satisfiedRules.some(rule =>
        this.question.rulesThatWouldShowQuestion?.includes(rule)
      );
    },
    required() {
      if (this.question.required) return true;
      if (this.question.rulesThatWouldRequireQuestion?.length === 0)
        return false;
      return this.satisfiedRules.some(rule =>
        this.question.rulesThatWouldRequireQuestion?.includes(rule)
      );
    }
  }
};
</script>

<style lang="sass" scoped>
.revision-request
  font-style: italic
  font-size: 16px

.revision-request-note
  font-weight: bold
</style>
